module.exports = __webpack_public_path__ + "img/register1.e254ba83.png";